<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="12">
				<h1 class="">Company Profile</h1>
			</v-col>
		</v-row>
		<v-row class="contentRow">
			<v-col>
				<h2>Company Registration
					<v-btn small @click="dialogRegistration()" color="primary" style="border-radius: 2px; float: right;" label
						v-if="!selectedCountry || !companyRegistrationNumber"
					>
						<v-icon small>fas fa-edit</v-icon>
					</v-btn>
				</h2>
				<br>
				<p>Company Name: <b>{{ clientName }}</b></p>
				<p v-if="selectedCountry || companyRegistrationNumber">Country of Operation: <b>{{ selectedCountry }}</b></p>
				<p v-if="selectedCountry || companyRegistrationNumber">Company Registration Number: <b>{{ companyRegistrationNumber }}</b></p>
				<p v-if="!selectedCountry || !companyRegistrationNumber">Please add your company registration details.</p>
				<!-- <p v-if="!hasCompanyData">Please add your company registration details.</p> -->
			</v-col>
		</v-row>
		<v-row class="contentRow">
			<v-col>
				<h2>Company Logo</h2>
				<p>Upload your company logo here. It will be visible in:</p>
				<ul>
					<li>
						Connections (on the connections page for your company)
					</li>
					<li>
						Notifications (all notifications your connections receive from you)
					</li>
					<li>
						Audit Submissions (when your supplier fills out your audit)
					</li>
				</ul>
				<p>
					Make sure the logo is not bigger than 500x500px and 2MB. It should
					also be square.
				</p>
				<v-file-input
					outlined
					accept=".png,.jpg"
					label="Add Logo"
					v-model="tmpFile"
					@change="fileChanged"
					v-if="!existingLogo"
				>
					<template v-slot:append>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
								color="primary"
								v-if="!existingLogo"
								:disabled="!tmpImgUrl"
								v-bind="attrs"
								v-on="on"
								@click="uploadLogo"
								>
								fas fa-cloud-arrow-up
								</v-icon>
							</template>
							<span>Upload</span>
						</v-tooltip>
					</template>
				</v-file-input>
				<br>
				<v-btn class="ma-2" color="primary" @click="dialogPolicy()" width="250">Add a company policy <v-icon right>fa-solid fa-pen-to-square</v-icon></v-btn>
				<v-btn class="ma-2 white--text" color="#325593" @click="dialogCertification()" width="250">Add a Certification <v-icon right>fa-solid fa-pen-to-square</v-icon></v-btn>
			</v-col>
			<v-col>
				<h3>Preview</h3>
				<i>This is how your logo will look on the Orixe platform</i>
				<br>
				<v-avatar color="grey lighten-2" class="ma-3" width="150" height="150">
					<v-img v-if="logoSrc" width="300" :src="logoSrc" />
					<v-icon v-else size="75">fas fa-building</v-icon>
				</v-avatar>
				<v-btn class="ma-2" color="error" :disabled="!existingLogo" @click="removeLogo" width="250">Remove existing logo <v-icon right>fas fa-times-circle</v-icon></v-btn>
				<v-list-item class="rounded my-1" style="border: 1px solid black">
						<v-list-item-avatar color="grey">
							<v-img v-if="logoSrc" :src="logoSrc" />
							<v-icon v-else small>fas fa-building</v-icon>
						</v-list-item-avatar>

						<v-list-item-content>
							<v-list-item-title>
								{{$store.getters["user/getUser"].clientName}} has sent you an audit request!
							</v-list-item-title>
							<v-list-item-subtitle>
								Received 15 minutes ago
							</v-list-item-subtitle>
						</v-list-item-content>
						<v-list-item-action>
							<v-btn icon>
								<v-icon
									color="grey lighten-2"
									>fas fa-times</v-icon
								>
							</v-btn>
						</v-list-item-action>
				</v-list-item>
				<v-sheet elevation="2" class="rounded pa-4 text-center mt-5" style="font-size: .8em">
					<v-row class="flex-grow-0">
						<v-col class="flex-grow-0 mr-0 pr-0">
							<v-avatar color="grey lighten-2" width="75" height="75">
								<v-img v-if="logoSrc" width="300" :src="logoSrc" />
								<v-icon v-else size="38">fas fa-building</v-icon>
							</v-avatar>
						</v-col>
						<v-col>
							<h2 class="font-weight-medium text-center">FILL OUT AUDIT</h2>
							<h1>Sent by {{$store.getters["user/getUser"].clientName}}</h1>
						</v-col>
					</v-row>
				</v-sheet>
				<br>
			</v-col>
		</v-row>
		<v-row class="contentRow">
			<v-col cols="12">
				<v-card elevation="0" outlined ref="companyPolicySection">
					<v-row>
						<v-col class="pt-6 pl-7">
							<h2>Company Policy Documents</h2>
							<p>You can see your company policy documents in here.</p>
						</v-col>
						<v-col class="d-flex justify-end mt-5 mr-5">
							<v-btn color="primary" outlined @click="policyGuide=true" width="250" class="mr-5">Guide to create a policy <v-icon right>fa-solid fa-pen-to-square</v-icon></v-btn>
							<v-btn color="primary" @click="dialogPolicy()" width="250">Add a company policy <v-icon right>fa-solid fa-pen-to-square</v-icon></v-btn>
						</v-col>
					</v-row>
					
					
					<v-col justify-center cols="12">
						<v-data-table
							theme--
							light
							:headers="policyHeaders"
							:items="policies"
							class="light table mx-4 completed-table"
							hide-default-footer
						>
							<template v-slot:item.timestamp="{ item }">
								{{ item.timestamp | moment("DD/MM/YYYY") }}
							</template>
							<template v-slot:item.download="{ item }">
								<v-btn color="primary"
									label
									small
									elevation="2"
									@click="downloadFiles(item.fileID, item.filename)">
									<v-icon left small>fas fa-download</v-icon>
									Download
								</v-btn>
							</template>
							<template v-slot:item.remove="{ item }">
								<v-btn small color="#B4B4B4" style="border-radius: 2px"
									v-on:click="showDeleteDialog(item)">
									<v-icon color="white" small>fas fa-times</v-icon>
								</v-btn>
							</template>
							<template v-slot:item.open="{ item }">
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<span
											v-bind="attrs"
											v-on="on"
											style="display: inline-block;"
										>
											<v-switch
												v-model="item.isOpen"
												color="primary"
												inset
												hide-details
												@change="toggleOpen(item)"
												style="margin-bottom: 15px;"
											></v-switch>
											<span @click="item.isOpen = !item.isOpen; toggleOpen(item)"></span>
										</span>
									</template>
									<span style="cursor: pointer;">{{ item.isOpen ? 'Close the button if you no longer want to share this document with your connection.' : 
										'Open the button if you need to share this document with your connection.' }}</span>
								</v-tooltip>
							</template>
						</v-data-table>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
		<v-dialog v-model="dialogFileDelete" max-width="500px">
			<v-card>
				<v-card-title class="justify-center"><span class="text-h5 pt-10 pb-3">Are you sure you want <br />to
						remove this file?</span></v-card-title>
				<v-card-actions class="justify-center pb-6">
					<v-btn color="primary" text @click="dialogFileDelete = false" outlined>Close</v-btn>
					<v-btn color="error" text @click="removeFile(itemToDelete.fileID)" outlined>Remove</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-row class="contentRow">
			<v-col cols="12">
				<v-card elevation="0" outlined>
					<v-row>
						<v-col class="pt-6 pl-7">
							<h2>Company Certifications</h2>
							<p>You can see your company certifications in here.</p>
						</v-col>
						<v-col class="d-flex justify-end mt-5 mr-5">
							<v-btn class="ma-2 white--text" color="#325593" @click="dialogCertification()" width="250">Add a Certification <v-icon right>fa-solid fa-pen-to-square</v-icon></v-btn>
						</v-col>
					</v-row>
					<v-col justify-center cols="12">
						<v-data-table
							theme--
							light
							:headers="certificationHeaders"
							:items="certifications"
							class="light table mx-4 completed-table"
							hide-default-footer
						>
							<template v-slot:item.timestamp="{ item }">
								{{ item.timestamp | moment("DD/MM/YYYY") }}
							</template>
							<template v-slot:item.expiryDate="{ item }">
								<v-tooltip v-if="isAboutToExpire(item.expiryDate)" bottom>
									<template v-slot:activator="{ on, attrs }">
										<span
											v-bind="attrs"
											v-on="on"
											:class="{ 'orange--text': isAboutToExpire(item.expiryDate) }"
										>
											{{ item.expiryDate | moment("DD/MM/YYYY") }}
										</span>
									</template>
									<span>Your certificate is about to expire</span>
								</v-tooltip>
								<v-tooltip v-else-if="isExpired(item.expiryDate)" bottom>
									<template v-slot:activator="{ on, attrs }">
										<span
											v-bind="attrs"
											v-on="on"
											:class="{ 'red--text': isExpired(item.expiryDate) }"
										>
											{{ item.expiryDate | moment("DD/MM/YYYY") }}
										</span>
									</template>
									<span>Your certificate has expired</span>
								</v-tooltip>
								<span v-else>
									{{ item.expiryDate | moment("DD/MM/YYYY") }}
								</span>
							</template>
							<template v-slot:item.download="{ item }">
								<v-btn color="#325593"
									style="color: white;"
									label
									small
									elevation="2"
									@click="downloadFiles(item.fileID, item.filename)">
									<v-icon left small>fas fa-download</v-icon>
									Download
								</v-btn>
							</template>
							<template v-slot:item.remove="{ item }">
								<v-btn small color="#B4B4B4" style="border-radius: 2px"
									v-on:click="showDeleteDialog(item)">
									<v-icon color="white" small>fas fa-times</v-icon>
								</v-btn>
							</template>
							<template v-slot:item.open="{ item }">
								<v-tooltip top>
									<template v-slot:activator="{ on, attrs }">
										<span
											v-bind="attrs"
											v-on="on"
											style="display: inline-block;"
										>
											<v-switch
												v-model="item.isOpen"
												color="#325593"
												inset
												hide-details
												@change="toggleOpen(item)"
												style="margin-bottom: 15px;"
											></v-switch>
											<span @click="item.isOpen = !item.isOpen; toggleOpen(item)"></span>
										</span>
									</template>
									<span style="cursor: pointer;">{{ item.isOpen ? 'Close the button if you no longer want to share this document with your connection.' : 
										'Open the button if you need to share this document with your connection.' }}</span>
								</v-tooltip>
							</template>
						</v-data-table>
					</v-col>
				</v-card>
			</v-col>
		</v-row>
		<v-row class="contentRow">
			<v-col>
				<h2>Company Name</h2>
				<p>
					Unfortunately, you can't change your company name here.
					<br>
					If you need to correct the name of your company, please contact us at <a href="mailto:support@orixe.se">support@orixe.se</a>.
				</p>
				
			</v-col>
		</v-row>
		<v-dialog v-model="updatePolicy" max-width="800px">
			<v-card class="text-center" style="padding: 20px">
				<h3 class="pa-5">Update Your Company Policy</h3>
				<v-text-field
					class="ml-8"
					outlined
					label="Short Description about policy"
					name="shortdescription"
					v-model="shortDescription"
					type="text"
					:rules="[(v) => !!v || 'Please add short description']"
				></v-text-field>
				<v-file-input
					outlined
					accept=".pdf"
					label="Upload Policy (Only PDF files are allowed for upload.)"
					v-model="policyFile"
					
					:rules="[(v) => !!v || 'Please upload a policy.']"
				></v-file-input>
				<v-alert v-if="errorMessage" type="error" class="ml-8">{{ errorMessage }}</v-alert>
				<v-col align="right" >
					<v-btn class="primary--text mr-5" :disabled="!canPolicySave" @click="companyPolicyDetails">
						Save
					</v-btn>
					<v-btn @click="closeDialog()" class="error--text">
						Close
					</v-btn>
				</v-col>
			</v-card>
		</v-dialog>
		<v-dialog v-model="updateCertification" max-width="800px">
			<v-card class="text-center" style="padding: 20px">
				<h3 class="pa-5">Update Your Company Certifications</h3>
				<v-text-field
					class="ml-8"
					outlined
					label="Short Description about certification"
					name="shortdescription"
					v-model="shortDescription"
					type="text"
					:rules="[(v) => !!v || 'Pleaseadd add short description.']"
				></v-text-field>
				<v-file-input
					outlined
					accept=".pdf"
					label="Upload Certification (Only PDF files are allowed for upload.)"
					v-model="policyFile"
					
					:rules="[(v) => !!v || 'Please upload a certification.']"
				></v-file-input>
				<v-text-field 
					class="ml-8"
					type="date" 
					outlined
					label="Expiry date of the certification"
					v-model="expiryDate"
				></v-text-field>
				<v-alert v-if="errorMessage" type="error" class="ml-8">{{ errorMessage }}</v-alert>
				<v-col align="right" >
					<v-btn class="primary--text mr-5" :disabled="!canCertificateSave" @click="companyPolicyDetails">
						Save
					</v-btn>
					<v-btn @click="closeDialog()" class="error--text">
						Close
					</v-btn>
				</v-col>
			</v-card>
		</v-dialog>
		<v-dialog v-model="registrationOpen" max-width="700px">
			<v-card v-model="valid">
				<v-card-title>Update Company Registration Details</v-card-title>
				<br>
				<v-card-text>
					<v-select
						outlined
						label="Country of Operation"
						v-model="selectedCountry"
						:items="filteredCountries"
						item-text="country"
						:rules="[(v) => !!v || 'Please select a country.']"
						menu-props="{ closeOnClick: false, closeOnContentClick: false }"
					>
						<template v-slot:prepend-item>
							<v-list-item>
								<v-list-item-content>
								<v-text-field
									v-model="searchText"
									label="Search Country"
									clearable
									@click:clear="clearSearch"
									@input="filterCountries"
								></v-text-field>
								</v-list-item-content>
							</v-list-item>
						</template>
					</v-select>
					<v-text-field
						outlined
						label="Company registration number (between 4-25 characters)"
						v-model="companyRegistrationNumber"
						name="companyregistration"
						append-icon="fas fa-address-card"
						type="text"
						:rules="[(v)=>{return !!v || 'This field is required.'},
							v => (v && v.length >= 4 && v.length <= 25) || 'Company registration number must be between 4 and 25 characters' 
						]"
					></v-text-field>
					<p>Please use the following link as an example to your country's company registration number 
						<b><a href="/Company_Registration_Number_Format.pdf" target="_blank">Company Registration Number Format</a></b>
					</p>
				</v-card-text>
				<v-card-actions class="ml-4">
					<v-btn color="primary" text :disabled="!isFormValid" type="submit" @click="updateregistrationDetails(selectedCountry, companyRegistrationNumber)" outlined
						>Update</v-btn
					>
					<v-btn color="error" text @click="registrationOpen = false" outlined
						>Cancel</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="policyGuide" max-width="1000px">
			<v-card class="text-left" style="padding: 30px">
				<div align="right" >
					<v-icon style="border: 1px solid red; padding: 5px;" small @click="policyGuide=false" class="error--text">fas fa-times</v-icon>
				</div>
				<h2 class="pt-3 pb-5 text-center primary--text">HOW TO CREATE A POLICY DOCUMENT</h2>
				<p>A policy document defines your organisation's direction, principles and commitments on a given topic. 
					It sits at the top of your management system - everything else (procedures, controls, training, reviews) exists to put the policy into practice.
					Use the questions below, in order, to build a complete and enforceable policy.</p>
				<br>

				<h4 class="primary--text">Step 1: Define the Vision</h4>
				<p>What should an organisation free from [the issue] look like?</p>
				<i>Describe a clear picture of the ideal state — how the organisation prevents the issue and promotes ethical, transparent and responsible practices related to it.</i><br>
				<i>Example (Anti-Corruption): An organisation where decisions are made with integrity, free from bribery or undue influence, and where transparency is the norm.</i>
				<br><br>

				<h4 class="primary--text">Step 2: Describe the Achieved State</h4>
				<p>If we had already achieved this vision, what would be true about the way we operate?</p>
				<i>Identify the fundamental behaviours, conditions and ways of working that would exist across the organisation and its business relationships if the vision were fully realised.</i>
				<br><br>

				<h4 class="primary--text">Step 3: Set the Guiding Principles</h4>
				<p>What principles should guide behaviour and decision-making on this topic?</p>
				<i>Define a small number of clear, memorable principles. These should address the specific risk areas relevant to the topic.</i><br>
				<i>Example (Anti-Corruption): approach to bribery, conflicts of interest, gifts and hospitality, improper payments, and relationships with business partners.</i>
				<br><br>

				<h4 class="primary--text">Step 4: State the Commitments</h4>
				<p>What are we committing ourselves to as an organisation?</p>
				<i>Express the organisation's core commitments — complying with applicable laws, acting with integrity, and addressing concerns or misconduct when they arise.</i>
				<br><br>

				<h4 class="primary--text">Step 5: Define the Scope</h4>
				<p>Who does this policy apply to?</p>
				<i>Be explicit: employees, contractors, agents, subsidiaries, joint ventures, and supply chain or business partners. A policy with unclear scope is difficult to enforce.</i>
				<br><br>

				<h4 class="primary--text">Step 6: Assign Roles and Responsibilities</h4>
				<p>Who is responsible for upholding and enforcing this policy?</p>
				<i>Identify who owns the policy, who monitors compliance, and who employees can go to with questions or concerns. This connects the policy to your Process & Roles step in the overall management system.</i>
				<br><br>

				<h4 class="primary--text">Step 7: Set Consequences</h4>
				<p>What happens if the policy is not followed?</p>
				<i>State the consequences of non-compliance clearly, so the policy has real weight rather than being aspirational only.</i>
				<br><br>

				<h4 class="primary--text">Step 8: Protect Reporting</h4>
				<p>How are concerns and reports protected?</p>
				<i>Confirm that anyone raising a concern in good faith is protected from retaliation. This builds trust and encourages issues to surface early — feeding into your Risk and Plan steps.</i>
				<br><br>

				<h4 class="primary--text">Step 9: Connect to Objectives</h4>
				<p>What should guide our objectives and future decisions?</p>
				<i>Ensure the policy gives clear direction for setting objectives, preventing the issue, and making responsible decisions — linking it forward to your Management Review step.</i>
				<br><br>

				<h4 class="primary--text">Step 10: Set a Review Cycle</h4>
				<p>How and when will this policy be reviewed?</p>
				<i>Define a review frequency (e.g. annually, or after major incidents or regulatory change) so the policy stays current and feeds into continuous improvement.</i>
				<br><br>

				<v-col align="right" >
					<v-btn @click="policyGuide=false" class="error--text">
						Close
					</v-btn>
				</v-col>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
/* import InvitationcodeAPI from "../../api/connections/invitationcodes" */
import LoadingState from "../../consts/LoadingState"
import LogoAPI from "../../api/clients/logo"
import CompanyregAPI from "../../api/clients/registration" 
import FilesAPI from "../../api/files/files"
import { mapGetters } from "vuex"

export default {
	name: "TeamSettings",
	data() {
		return {
			policyFile: null,
			policies: [],
			certifications: [],
			tmpImgUrl: null,
			tmpFile: null,
			tmpFile2: null,
			updatePolicy: false,
			updateCertification: false,
			country: null,
			companyregistration: null,
			valid: false,
			registrationOpen: false,
			notEmptyRules: [(v) => !!v || "This field cannot be empty"],
			policyHeaders: [
				{
					text: "Policy Name",
					value: "filename",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Description",
					value: "shortDescription",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Download",
					value: "download",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Remove",
					value: "remove",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Open",
					value: "open",
					sortable: false,
					class: "secondary--text"
				}
			],
			certificationHeaders: [
				{
					text: "Certification Name",
					value: "filename",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Description",
					value: "shortDescription",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Expiry Date",
					value: "expiryDate",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Download",
					value: "download",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Remove",
					value: "remove",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Open",
					value: "open",
					sortable: false,
					class: "secondary--text"
				}
			],
			selectedCountry: null,
			countries: [
				{ country: "Afghanistan" }, { country: "Albania" }, { country: "Algeria" }, { country: "Andorra" }, { country: "Angola" }, { country: "Antigua and Barbuda" }, 
				{ country: "Argentina" }, { country: "Armenia" }, { country: "Australia" }, { country: "Austria" }, { country: "Azerbaijan" },
				{ country: "Bahamas" }, { country: "Bahrain" }, { country: "Bangladesh" }, { country: "Barbados" }, { country: "Belarus" }, { country: "Belgium" }, 
				{ country: "Belize" }, { country: "Benin" }, { country: "Bhutan" }, { country: "Bolivia" }, { country: "Bosnia and Herzegovina" }, { country: "Botswana" },
				{ country: "Brazil" }, { country: "Brunei" }, { country: "Bulgaria" }, { country: "Burkina Faso" }, { country: "Burundi" }, 
				{ country: "Cambodia" }, { country: "Cameroon" }, { country: "Canada" }, { country: "Cape Verde" }, { country: "Cayman Islands" }, { country: "	Central African Republic" },
				{ country: "Chad" }, { country: "Chile" }, { country: "China" }, { country: "Christmas Island" }, { country: "Cocos (Keeling) Islands" }, { country: "Colombia" },
				{ country: "Comoros" }, { country: "Democratic Republic of the Congo" }, { country: "Congo, Republic of (Brazzaville)" }, { country: "	Cook Islands" },
				{ country: "Costa Rica" }, { country: "Côte D'ivoire (Ivory Coast)" }, { country: "Croatia" }, { country: "Cuba" }, { country: "Cyprus" }, { country: "	Czech Republic" },
				{ country: "Denmark" }, { country: "Djibouti" }, { country: "Dominica" }, { country: "Dominican Republic" },
				{ country: "East Timor (Timor-Leste)" }, { country: "Ecuador" }, { country: "Egypt" }, { country: "El Salvador" }, { country: "Equatorial Guinea" }, { country: "Eritrea" },
				{ country: "Estonia" }, { country: "Ethiopia" }, 
				{ country: "Falkland Islands" }, { country: "Faroe Islands" }, { country: "Fiji" }, { country: "Finland" }, { country: "France" }, { country: "French Guiana" },
				{ country: "French Polynesia" }, { country: "French Southern Territories" },
				{ country: "Gabon" }, { country: "The Gambia" }, { country: "Georgia" }, { country: "Germany" }, { country: "Ghana" }, { country: "Gibraltar" },
				{ country: "Greece" }, { country: "Greenland" }, { country: "Grenada" }, { country: "Guadeloupe" }, { country: "Guam" }, { country: "Guatemala" },
				{ country: "Guinea" }, { country: "Guinea-Bissau" }, { country: "Guyana" },
				{ country: "Haiti" }, { country: "Holy See" }, { country: "Honduras" }, { country: "Hong Kong" }, { country: "Hungary" },
				{ country: "Iceland" }, { country: "India" }, { country: "Indonesia" }, { country: "Iran" }, { country: "Iraq" }, { country: "Ireland" },
				{ country: "Israel" }, { country: "Italy" }, { country: "Ivory Coast" },
				{ country: "Jamaica" }, { country: "Japan" }, { country: "Jordan" }, 
				{ country: "Kazakhstan" }, { country: "Kenya" }, { country: "Kiribati" }, { country: "Korea, Democratic People's Rep. (North Korea)" }, { country: "Korea, Republic of (South Korea)" }, 
				{ country: "Kosovo" }, { country: "Kuwait" }, { country: "Kyrgyzstan" },
				{ country: "Laos" }, { country: "Latvia" }, { country: "Lebanon" }, { country: "Lesotho" }, { country: "Liberia" }, { country: "Libya" },
				{ country: "Liechtenstein" }, { country: "Lithuania" }, { country: "Luxembourg" },
				{ country: "Macau" }, { country: "Madagascar" }, { country: "Malawi" }, { country: "Malaysia" }, { country: "Maldives" }, { country: "Mali" },
				{ country: "Malta" }, { country: "Marshall Islands" }, { country: "Martinique" }, { country: "Mauritania" }, { country: "Mauritius" }, { country: "Mayotte" },
				{ country: "Mexico" }, { country: "Micronesia" }, { country: "Moldova" }, { country: "Monaco" }, { country: "Mongolia" }, { country: "Montenegro" },
				{ country: "Montserrat" }, { country: "Morocco" }, { country: "Mozambique" }, { country: "Myanmar" }, 
				{ country: "Namibia" }, { country: "Nauru" }, { country: "Nepal" }, { country: "Netherlands" }, { country: "Netherlands Antilles" }, { country: "New Caledonia" },
				{ country: "New Zealand" }, { country: "Nicaragua" }, { country: "Niger" }, { country: "Nigeria" }, { country: "Niue" }, { country: "North Macedonia" },
				{ country: "Northern Mariana Islands" }, { country: "Norway" }, 
				{ country: "Oman" }, 
				{ country: "Pakistan" }, { country: "Palau" }, { country: "Palestine" }, { country: "Panama" }, { country: "Papua New Guinea" }, { country: "Paraguay" },
				{ country: "Peru" }, { country: "Philippines" }, { country: "Pitcairn Island" }, { country: "Poland" }, { country: "Portugal" }, { country: "Puerto Rico" },
				{ country: "Qatar" }, 
				{ country: "Reunion Island" }, { country: "Romania" }, { country: "Russian Federation" }, { country: "Rwanda" }, 
				{ country: "Saint Kitts and Nevis" }, { country: "Saint Lucia" }, { country: "Saint Vincent and the Grenadines" }, { country: "Samoa" },
				{ country: "San Marino" }, { country: "Sao Tome and Principe" }, { country: "Saudi Arabia" }, { country: "Senegal" }, { country: "Serbia" }, { country: "Seychelles" },
				{ country: "Sierra Leone" }, { country: "Singapore" }, { country: "Slovakia" }, { country: "Slovenia" }, { country: "Solomon Islands" }, { country: "Somalia" },
				{ country: "South Africa" }, { country: "South Sudan" }, { country: "Spain" }, { country: "Sri Lanka" }, { country: "Sudan" }, { country: "Suriname" },
				{ country: "Swaziland" }, { country: "Sweden" }, { country: "Switzerland" }, { country: "Syria" },
				{ country: "Taiwan" }, { country: "Tajikistan" }, { country: "Tanzania" }, { country: "Thailand" }, { country: "Tibet" }, { country: "Timor-Leste" },
				{ country: "Togo" }, { country: "Tokelau" }, { country: "Tonga" }, { country: "Trinidad and Tobago" }, { country: "Tunisia" }, { country: "Turkey" },
				{ country: "Turkmenistan" }, { country: "Turks and Caicos Islands" }, { country: "Tuvalu" }, 
				{ country: "Uganda" }, { country: "Ukraine" }, { country: "United Arab Emirates" }, { country: "United Kingdom" }, { country: "United States" },
				{ country: "Uruguay" }, { country: "Uzbekistan" }, 
				{ country: "Vanuatu" }, { country: "Vatican City State" }, { country: "Venezuela" }, { country: "Vietnam" },
				{ country: "Virgin Islands (British)" }, { country: "Virgin Islands (U.S.)" },
				{ country: "Wallis and Futuna Islands" }, { country: "Western Sahara" },
				{ country: "Yemen" },
				{ country: "Zambia" }, { country: "Zimbabwe" },
			],
			searchText: "",
			companyRegistrationNumber: "",
			hasCompanyData: false,
			shortDescription: "",
			expiryDate: null,
			errorMessage: "",
			dialogFileDelete: false,
			dialogCertificateDelete: false,
			itemToDelete: null,
			fileInfo: {},
			policyGuide: false
		}
	},
	created() {},
	mounted() {
		this.getRegistrationDetails()
		this.viewFile()
		this.scrollToPolicyIfRequested()
	},
	watch: {
		"$route.query.scrollTo"(newVal) {
			if (newVal === "companyPolicy") {
				this.scrollToPolicyIfRequested()
			}
		}
	},
	computed: {
		logoSrc() {
			return this.tmpImgUrl || this.$store.getters["user/getUser"].companyLogo
		},
		existingLogo() {
			return this.$store.getters["user/getUser"].companyLogo
		},
		...mapGetters("user", ["isLoggedIn", "getUser"]),
		filteredCountries() {
			const searchTerm = this.searchText.toLowerCase().trim()
			if (!searchTerm) {
				return [...this.countries]
			} else {
				return this.countries.filter(
					(country) =>
						country.country.toLowerCase().includes(searchTerm)
				)
			}
		},
		clientName() {
			return this.getUser.clientName
		},
		username() {
			return this.getUser.username
		},
		canPolicySave() {
			return this.shortDescription && this.policyFile
		},
		canCertificateSave() {
			return this.expiryDate && this.shortDescription && this.policyFile
		},
		isFormValid() {
			return (
				this.selectedCountry && this.companyRegistrationNumber
			)
		}
		/* hasCountryAndRegNumber() {
			return this.selectedCountry && this.companyRegistrationNumber
		}, */
	},
	methods: {
		scrollToPolicyIfRequested() {
			if (this.$route.query.scrollTo === "companyPolicy") {
				this.$nextTick(() => {
					setTimeout(() => {
						const el = this.$refs.companyPolicySection?.$el
						if (el) {
							el.scrollIntoView({ behavior: "smooth", block: "start" })
						}
					}, 300)
				})
			}
		},
		clearSearch() {
			this.searchText = ""
			this.filterCountries()
		},
		isExpired(expiryDate) {
			return new Date(expiryDate) < new Date()
		},
		isAboutToExpire(expiryDate) {
			const now = new Date()
			const oneMonthLater = new Date(now)
			oneMonthLater.setMonth(now.getMonth() + 1)
			return new Date(expiryDate) < oneMonthLater && new Date(expiryDate) >= now
		},
		closeDialog(){
			this.updatePolicy = false
			this.updateCertification = false
			window.location.reload()
		},
		companyPolicyDetails() {
			if (this.updatePolicy && this.policies.length >= 5) {
				this.errorMessage = "You can only upload up to 5 policies."
				return
			}
			if (this.updateCertification && this.certifications.length >= 5) {
				this.errorMessage = "You can only upload up to 5 certifications."
				return
			}

			const fileName = this.policyFile.name.replace(/\.[^/.]+$/, "")
			const user = this.$store.getters["user/getUser"]
			const updatedby = user.username
			const shortDescription = this.shortDescription
			const timestamp = new Date().toISOString().slice(0, 19).replace("T", " ")
			const expiryDate = this.expiryDate
			const filedata = this.policyFile
			const isCertificate = this.updateCertification
			const policyCertificateFlag = isCertificate ? 1 : 0
			const fileSize = this.policyFile.size

			if (fileSize > 5242880){
				this.errorMessage = "Please upload a PDF file that is 5MB or smaller"
				return
			}

			this.uploadPolicy(updatedby, fileName, shortDescription, timestamp, expiryDate, filedata, policyCertificateFlag)
		},
		uploadPolicy(updatedby, fileName, shortDescription, timestamp, expiryDate, filedata, policyCertificateFlag){
			this.updatePolicy = false
			this.updateCertification = false
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			FilesAPI.postFile(updatedby, fileName, shortDescription, timestamp, expiryDate, filedata, policyCertificateFlag)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Successfully Updated policy!",
						{ root: true }
					)
					setTimeout(() => {
						window.location.reload()
					}, 1000)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		viewFile(){
			FilesAPI.getFiledata()
				.then((data) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.policies = data.filter(policyFile => policyFile.PolicyCertificate === 0).map((filedata) => ({
						number: 0,
						fileID: filedata.FileID,
						filename: filedata.FileName,
						shortDescription: filedata.ShortDescription,
						updatedby: filedata.UserID,
						timestamp: filedata.TimeOfUpload,
						isOpen: filedata.IsOpen === 1,
					})).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
						.map((item, index) => ({
							...item,
							number: index + 1,
						}))
					this.certifications = data.filter(policyFile => policyFile.PolicyCertificate === 1).map(filedata => ({
						no: 0,
						fileID: filedata.FileID,
						filename: filedata.FileName,
						shortDescription: filedata.ShortDescription,
						updatedby: filedata.UserID,
						timestamp: filedata.TimeOfUpload,
						expiryDate: filedata.ExpiryDate,
						isOpen: filedata.IsOpen === 1,
					})).sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
						.map((item, index) => ({
							...item,
							no: index + 1,
						}))
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		downloadFiles(fileID, filename) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Downloading file...",
				{ root: true }
			)
			/* let filename = this.filename(fileID) */
			FilesAPI.downloadFile("" + fileID, filename)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"File was successfully downloaded!",
						{ root: true }
					)
				})
				.catch(err => {
					console.error(err)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{
							root: true
						}
					)
				})
		},
		filename(fileID) {
			if (this.fileInfo[fileID]) {
				return this.fileInfo[fileID].name
			}
			return this.name ? this.name + ".pdf" : "attachment.pdf"
		},
		dialogPolicy(){
			this.updatePolicy = true
			this.errorMessage = ""
		},
		dialogCertification(){
			this.updateCertification = true
			this.errorMessage = ""
		},
		dialogRegistration(){
			this.registrationOpen = true
		},
		/* viewCertificate(url) {
			window.open(url, "_blank")
		}, */
		showDeleteDialog(item) {
			this.itemToDelete = item
			this.dialogFileDelete = true
		},
		updateregistrationDetails(selectedCountry, companyRegistrationNumber){
			this.registrationOpen = false
			CompanyregAPI.updateRegistration(selectedCountry, companyRegistrationNumber)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Sucessfully Updated Action!",
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},

		getRegistrationDetails() {
			CompanyregAPI.getRegistration()
				.then(data => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
					this.companyRegistrationNumber = data[0].number
					this.selectedCountry = data[0].country
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		removeFile(fileID) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Removing file...",
				{ root: true }
			)
			FilesAPI.deleteCompanyFile(fileID)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"File removed successfully!",
						{ root: true }
					)
					setTimeout(() => {
						this.viewFile()
					}, 1000)
				})
				.catch((reason) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				}) 
			this.dialogFileDelete = false
		},
		fileChanged() {
			if (!this.tmpFile) {
				this.tmpImgUrl = null
				return
			}
			const file = this.tmpFile
			let image = new Image()
			image.src = URL.createObjectURL(file)
			let boundResize = this.resizeCrop.bind(this)
			image.onload = (e) => {
				var mybase64resized = boundResize(e.target, 400, 0)
				/* let res2 = mybase64resized.toDataURL(
					"image/jpg",
					90
				) */
				this.tmpImgUrl = mybase64resized
			}
		},
		removeLogo() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Uploading logo...",
				{ root: true }
			)
			LogoAPI.removeLogo()
				.then(() => {
					this.tmpImgUrl = null
					this.tmpFile = null
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Logo was removed!",
						{ root: true }
					)
					this.$store.dispatch("user/verifyLogin")
				})
				.catch(err => {
					console.error(err)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{ root: true }
					)
				})
		},
		uploadLogo() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Uploading logo...",
				{ root: true }
			)
			LogoAPI.uploadLogo(this.tmpImgUrl)
				.then(() => {
					this.tmpImgUrl = null
					this.tmpFile = null
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Logo was uploaded!",
						{ root: true }
					)
					this.$store.dispatch("user/verifyLogin")
				})
				.catch(err => {
					console.error(err)
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{ root: true }
					)
					this.tmpFile = null
					this.tmpImgUrl = null
				})
		},
		resizeCrop(src, width, height) {
			var crop = width == 0 || height == 0
			// not resize
			if (src.width <= width && height == 0) {
				width = src.width
				height = src.height
			}
			// resize
			if (src.width > width && height == 0) {
				height = src.height * (width / src.width)
			}

			// check scale
			var xscale = width / src.width
			var yscale = height / src.height
			var scale = crop ? Math.min(xscale, yscale) : Math.max(xscale, yscale)
			// create empty canvas
			var canvas = document.createElement("canvas")
			canvas.width = width ? width : Math.round(src.width * scale)
			canvas.height = height ? height : Math.round(src.height * scale)
			var ctx = canvas.getContext("2d")
			ctx.scale(scale, scale)
			// crop it top center
			ctx.fillStyle = "rgb(255,255,255)"
			ctx.fillRect((src.width * scale - canvas.width) * -0.5,(src.height * scale - canvas.height) * -0.5,src.width,src.height)
			ctx
				.drawImage(
					src,
					(src.width * scale - canvas.width) * -0.5,
					(src.height * scale - canvas.height) * -0.5
				)
			return canvas.toDataURL("image/jpeg", 90)
		},
		toggleOpen(item) {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				"Updating visibility...",
				{ root: true }
			)
			FilesAPI.setOpenStatus(item.fileID, item.isOpen)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						item.isOpen ? "File is now visible to your connections." : "File is now hidden from your connections.",
						{ root: true }
					)
				})
				.catch(err => {
					// revert the switch in the table since the update failed
					item.isOpen = !item.isOpen
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						err,
						{ root: true }
					)
				})
		},
	},
}
</script>
